class BlockBranding {
  // eslint-disable-next-line class-methods-use-this
  getColorBelowElement(el) {
    const rect = el.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const elements = document.elementsFromPoint(centerX, centerY);
    const header =
      el.closest('header') || document.querySelector('header[role="banner"]');

    for (let i = 0; i < elements.length; i++) {
      const candidate = elements[i];
      const isElOrDescendant = candidate === el || el.contains(candidate);
      const isHeaderSubtree =
        header && (candidate === header || header.contains(candidate));

      if (!isElOrDescendant && !isHeaderSubtree) {
        const style = getComputedStyle(candidate);
        const bg = style.backgroundColor;
        const bgImage = style.backgroundImage;

        if (bgImage && bgImage !== 'none' && /gradient/.test(bgImage)) {
          return 'white';
        }

        if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
          const isWhite =
            bg === 'rgb(255, 255, 255)' || bg === 'rgba(255, 255, 255, 1)';
          const isDefault = bg === 'rgb(234, 231, 220)';

          if (isWhite || isDefault) {
            return 'blue';
          }

          return 'white';
        }
      }
    }

    return 'blue';
  }

  // eslint-disable-next-line class-methods-use-this
  applyLogoColor(mask, color) {
    mask.style.backgroundColor = color === 'white' ? '#ffffff' : '#003dbb';
  }

  run() {
    const { getColorBelowElement, applyLogoColor } = this;

    Drupal.behaviors.blockBrandingColors = {
      attach() {
        const masks = Array.from(
          document.querySelectorAll(
            '#block-sanarenatheme26-branding .site-logo .site-logo__mask, .site-logo-main-navigation .site-logo__mask'
          )
        );

        if (!masks.length) {
          return;
        }

        let throttleTimer = null;

        const updateLogoColors = () => {
          masks.forEach((mask) => {
            const color = getColorBelowElement(mask);
            applyLogoColor(mask, color);
          });
        };

        updateLogoColors();

        window.addEventListener('scroll', () => {
          if (throttleTimer) {
            return;
          }

          throttleTimer = setTimeout(() => {
            updateLogoColors();
            throttleTimer = null;
          }, 100);
        });

        window.addEventListener('resize', () => {
          if (throttleTimer) {
            return;
          }

          throttleTimer = setTimeout(() => {
            updateLogoColors();
            throttleTimer = null;
          }, 100);
        });
      }
    };
  }
}

export default BlockBranding;
